import { render } from "./ScoringSurveysPage.vue?vue&type=template&id=512fb8af&ts=true"
import script from "./ScoringSurveysPage.vue?vue&type=script&lang=ts"
export * from "./ScoringSurveysPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__